export default __webpack_public_path__ + "static/media/printer_service.6eec9c5b.jpg";